import { makeStyles, TextField } from "@material-ui/core";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { handleKeywordKeyPress } from "../../../common/handleKeyWordPress";
import { verifyPhoneUrl } from "../../../common/infrastructure/endpoints";
import { post } from "../../../common/infrastructure/requests";

interface IEnterPhoneNumber {
  setProposedPhoneNumber: any;
  phoneNumber: string;
}
const useStyles = makeStyles({
  button: {
    marginBottom: "1rem",
  },
});

export const EnterPhoneNumber: React.FC<IEnterPhoneNumber> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const handleGoNext = async () => {
    try {
      if (!isValidPhoneNumber(props.phoneNumber)) {
        setErrorMessage(
          t(
            "You have entered an incorrect phone number. Only + and numbers are allowed"
          )
        );
        return;
      }

      const resp = await post<any, { phonenumber: string }>(verifyPhoneUrl(), {
        phonenumber: props.phoneNumber,
      });

      if (resp) {
        setErrorMessage("");
        //@ts-ignore
        props.nextStep();
        return;
      }
    } catch (e) {
      setErrorMessage(t("System error, please try again later."));
    }
  };

  const isValidPhoneNumber = (phoneNumber: string) =>
    phoneNumber.match(/^[0-9\+\/]+/) ? true : false;
  return (
    <Grid container direction="column" wrap="nowrap">
      <DialogContent>
        <DialogTitle>{t("Phone number")}</DialogTitle>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={t("Enter Phone number")}
          required
          type="tel"
          onChange={(e) => props.setProposedPhoneNumber(e.target.value)}
          helperText={errorMessage}
          classes={{ root: classes.button }}
          onKeyDown={(e) => handleKeywordKeyPress(e, handleGoNext)}
        />
        <DialogContentText color="primary">
          {t(
            "Enter the phone number to which you wish to receive an SMS to be able to use the shell protection in your apartment. We will send you a verification code to confirm the phone number. You can then activate or deactivate the shell protection based on what suits you."
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          disabled={props.phoneNumber.length < 10}
          onClick={() => handleGoNext()}
        >
          {t("Send verification code")}
        </Button>
      </DialogActions>
    </Grid>
  );
};
